<template>
  <v-data-table
	:headers="headers"
    :items="dataUnits"
    :items-per-page="5"
    class="elevation-1"
  ></v-data-table>
</template>

<script>
export default {
	name: 'BlockTable',
    data () {
      return {
        headers: [
        {
        text: 'Data Unit Index',
            align: 'start',
            sortable: false,
            value: 'dataUnitIndex',
			},
			{ text: 'Transaction ID', value: 'transactionID' },
			{ text: 'Hash', value: 'hash' },
			{ text: 'Status', value: 'status' },
			{ text: 'Location', value: 'location' },
        ],
        dataUnits: [
        {	
			dataUnitIndex: '22112',
            transactionID: '314',
            hash: '99242c013572cb63292392dfc58bdb001000cc7aa143485913399216a37ac087',
            status: 0,
            location: 'MAIN',
        },
        {
			dataUnitIndex: '22113',
            transactionID: '315',
            hash: '5b93aef3f57947bb5b4da03dc79b0a6a19f6dc06d3eece7e37a4746ebabf905c',
            status: 9,
            location: 'MAIN',
			},
		{
			dataUnitIndex: '22114',
            transactionID: '351',
            hash: 'c67463f48792389c6c0ea518f205b734e9d8380a9ee4b33e3810271b0166611f',
            status: 0,
			location: 'MAIN',
			},
        ],
      }
    },
  }
</script>